import { motion } from "framer-motion";
import { BookOpen, Sparkles, Brain, Map } from "lucide-react";

const stats = [
  { icon: Sparkles, value: "80+", label: "Activities", color: "text-amber-600 bg-amber-100 border-amber-300" },
  { icon: BookOpen, value: "50+", label: "Stories", color: "text-rose-600 bg-rose-100 border-rose-300" },
  { icon: Brain, value: "30+", label: "Quizzes", color: "text-violet-600 bg-violet-100 border-violet-300" },
  { icon: Map, value: "6", label: "Learning Paths", color: "text-cyan-600 bg-cyan-100 border-cyan-300" },
];

const PlatformStats = () => {
  return (
    <section className="py-10 bg-cyan-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-fredoka font-bold text-gray-800 mb-1">
            Trusted by Parents for Real Progress 💛
          </h2>
          <p className="text-gray-600 text-sm md:text-base font-quicksand">
            Designed to build skills, confidence and curiosity — every day.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className={`${s.color} border-2 rounded-2xl p-4 text-center shadow-sm`}
              >
                <Icon className="w-7 h-7 mx-auto mb-1.5" />
                <div className="font-fredoka font-extrabold text-2xl md:text-3xl leading-none">
                  {s.value}
                </div>
                <div className="text-xs md:text-sm font-bold mt-1">{s.label}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PlatformStats;
